import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

/**
 * Gets the data for master schedule screen export.
 * @param {number} campaignId
 */
export const getMasterScheduleData = async ({ campaignId, ...params }) => {
  const query = `query 
  (
    $campaignId:ID!
    $first: Int
    $after: String
    $locationId:ID
    $cityId:ID
    $statusAndAbove: MissionStatusEnum
    $statusAndBelow: MissionStatusEnum
    $timeOfDay: MissionTimeOfDayEnum
    $filter:String
    $orderBy:MissionOrderByEnum
    $dayOfTheWeek:DayOfTheWeekEnum
    $startDate:String
    $endDate:String
    ) {
      campaign(id:$campaignId){
        missions(
          first: $first,
          after: $after
          locationId: $locationId
          statusAndAbove: $statusAndAbove
          statusAndBelow: $statusAndBelow
          timeOfDay: $timeOfDay
          filter: $filter
          orderBy: $orderBy
          dayOfTheWeek: $dayOfTheWeek
          startDate: $startDate
          endDate: $endDate
          cityId: $cityId
          ) {
          totalCount
          edges {
            node {
              id
              flyerCode
              status
              totalFlyersDistributed
              dateTime
              distributionCost
              packSize
              printingCostPerFlyer
              type
              timeOfDay
              flyerCodeV2 {
                tag
                code
              }
              cityPlan {
                city {
                  name
                  lunchCheckInTime
                  afternoonCheckInTime
                  timezone
                }
              }
              user {
                id
                firstName
                lastName
              }
              location {
                id
                name
                type {
                  name
                }
              }
              metricResults {
                nodes {
                  id
                  value
                  metric {
                    id
                    name
                  }
                }
              }
              label
              amountScans
              spyInformation{
                spy{
                  id
                  firstName
                  lastName
                }
                spyDetails{
                  checkInTime
                  checkoutTime
                  reportReason
                  }
                shift{
                  id
                }
              }
            }
          }
        }
        cityPlans {
          nodes {
            id
            city {
              id
              name
              lunchCheckInTime
              afternoonCheckInTime
              timezone
              locations {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    ...params,
  })
  return response.json()
}

/**
 * Gets the data for master schedule missions import.
 * @param {number} campaignId
 */
export const getDataForMissionsImport = async campaignId => {
  const query = `query ($campaignId:ID!) {
      campaign(id:$campaignId){
        cityPlans {
          nodes {
            city {
              brandAmbassadors {
                edges {
                  node {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
  return response.json()
}

export const gqlCampaign = `query ($campaignId:ID!) {
    campaign(id:$campaignId){
      cityPlans{
        nodes {
           id
        }
      }
    }
  }`

export const gqlCityPlans = `
  query ($cityPlanId:ID!) {
    cityPlans(cityPlanId: $cityPlanId) {
      edges {
        node {
          id
          city {
            name
            lunchCheckInTime
            afternoonCheckInTime
          }
          permitCosts {
            nodes {
              startDate
              cost
            }
          }
        }
      }
    }
  }
  `

export const gqlMissions = `
   query ($cityPlanId:ID!, $missionStatuses: [MissionStatusEnum], $first: Int, $skip: Int) {
    cityPlans(cityPlanId: $cityPlanId) {
      edges {
        node {
           id
            missions(statuses: $missionStatuses, first: $first, skip: $skip) {
              pageInfo {
                hasNextPage
              }  
              edges {
                node {
                  id
                  flyerCode
                  status
                  totalFlyersDistributed
                  dateTime
                  distributionCost
                  printingCostPerFlyerV2
                  packSize
                  bonusPerConversion
                  bonusRedemptionPeriod
                  type
                  flyerCodeV2 {
                    tag
                    code
                  }
                  user {
                    firstName
                    lastName
                  }
                  location {
                    id
                    name
                    hasPermit
                    type {
                      name
                    }
                  }
                  metricResults {
                    nodes {
                      id
                      value
                      metric {
                        id
                        name
                      }
                    }
                  }
                  conversions {
                    nodes {
                      id
                      timestamp
                      metric {
                        isPrimary
                      }
                    }
                  }
                  label
                  amountScans
                }
              }
            }
        }
      }
    }
  }
  `



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/MasterSchedule/gql.js